// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__37mme","head":"ProcedureTableInfo_head__3a9XJ"};